import { render, staticRenderFns } from "./Webm.vue?vue&type=template&id=354f12c4&"
import script from "./Webm.vue?vue&type=script&lang=js&"
export * from "./Webm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports